import {
	defaultShouldDehydrateQuery,
	isServer,
	MutationCache,
	type Query,
	QueryCache,
	QueryClient,
} from "@tanstack/react-query";
import { errorHandler } from "./errors";

let browserQueryClient: QueryClient | undefined;

const makeQueryClient = () => {
	return new QueryClient({
		queryCache: new QueryCache({
			onError: (error) => {
				errorHandler({
					error,
					source: "Query Client",
					operation: "Query Execution Failed",
				});
			},
		}),
		mutationCache: new MutationCache({
			onError: (error) => {
				errorHandler({
					error,
					source: "Query Client",
					operation: "Mutation Execution Failed",
				});
			},
		}),
		defaultOptions: {
			queries: {
				staleTime: 60 * 1000,
				throwOnError: true,
			},
			dehydrate: {
				// include pending queries in dehydration
				shouldDehydrateQuery: (query: Query) =>
					defaultShouldDehydrateQuery(query) ||
					query.state.status === "pending",
			},
		},
	});
};

export const getQueryClient = () => {
	if (isServer) {
		// Server: always make a new query client
		return makeQueryClient();
	}
	if (!browserQueryClient) {
		browserQueryClient = makeQueryClient();
	}
	return browserQueryClient;
};
